export default __webpack_public_path__ + "static/media/placeholder_store05-jp-web.f224c82e.png";